var React = require('react');

function ChevronIkon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16.171492,41.999998c-4.143269,0-8.2852797,1.57464-11.4277496,4.706478-6.3249899,6.283609-6.3249899,16.499474,0,22.803034l84.0286676,83.76282c6.30496,6.30356,16.54928,6.30356,22.87426,0l83.60959-83.26412c6.32499-6.28361,6.32499-16.499477,0-22.803038-6.30496-6.30356-16.55553-6.30356-22.88051,0l-72.13806,71.893768-72.613438-72.373767c-3.14247-3.151781-7.29074-4.725174-11.433999-4.725174h-0.0188z"}));
}

ChevronIkon.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = ChevronIkon;

ChevronIkon.default = ChevronIkon;
